import { createSlice, current, PayloadAction } from '@reduxjs/toolkit'
import {
  AuthProfileState,
  AuthUserClient,
  SiteSettingsType,
  UserAuthPayload,
} from '../types/auth.types'

const initialState: AuthProfileState = {
  isAuthenticated: true,
  user: null,
  selectedClientTenant: null,
  agentSubscribeTime: { subscribeTime: null, agentId: null },
  versionDetails: null,
  site_settings: null,
}

const authSlice = createSlice({
  name: 'authUser',
  initialState,
  reducers: {
    setAuthProfile: (
      state,
      action: PayloadAction<Partial<AuthProfileState>>
    ) => {
      if (action.payload.user !== undefined) {
        state.user = action.payload.user
      }
      if (action.payload.isAuthenticated !== undefined) {
        state.isAuthenticated = action.payload.isAuthenticated
      } else if (action.payload.user !== undefined) {
        state.isAuthenticated = action.payload.user !== null
      }
      if (action.payload.selectedClientTenant !== undefined) {
        state.selectedClientTenant = action.payload.selectedClientTenant
      }
      if (action.payload.agentSubscribeTime !== undefined) {
        state.agentSubscribeTime = action.payload.agentSubscribeTime
      }
      if (action.payload.versionDetails !== undefined) {
        state.versionDetails = action.payload.versionDetails
      }
      if (action.payload.site_settings !== undefined) {
        state.site_settings = action.payload.site_settings
      }
    },
    logoutAuthProfile: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.selectedClientTenant = null
      state.agentSubscribeTime = { subscribeTime: null, agentId: null }
      state.versionDetails = null
      state.site_settings = null
    },
    updateAuthUserSelectedTenant: (state, { payload }) => {
      const readableState = current(state)
      if (
        readableState?.user?.clients &&
        readableState?.user?.clients?.length > 0
      ) {
        const selectedTenantObj: AuthUserClient =
          readableState?.user?.clients.filter(
            (tenant) => tenant.id == payload
          )[0]
        if (selectedTenantObj) {
          state.selectedClientTenant = selectedTenantObj
        } else {
          state.selectedClientTenant = null
        }
      }
    },
    getUserInfo: (state, action: PayloadAction<UserAuthPayload>) => {
      console.log('updateAuthUserSelectedTenant', state, action.payload)
    },
    toggleClientEnabled: (state, action: PayloadAction<number[]>) => {
      if (state?.user?.clients) {
        state.user.clients = state?.user?.clients?.map((client) => {
          if (action?.payload?.includes(client.id)) {
            if (
              client.enabled &&
              state.selectedClientTenant?.id === client.id &&
              state.user
            ) {
              state.selectedClientTenant = state.user.clients[0]
            }
            return { ...client, enabled: !client.enabled }
          } else return client
        })
      }
    },
    setAgentSubscribeTime: (
      state,
      action: PayloadAction<{ subscribeTime: number; agentId: string }>
    ) => {
      state.agentSubscribeTime = action.payload
    },
    getVersionInfo: (state, action: PayloadAction<UserAuthPayload>) => {
      console.log('version details', state, action.payload)
    },
    setVersionDetails: (state, action: PayloadAction<string>) => {
      state.versionDetails = action.payload
    },
    setSiteSettings: (state, action: PayloadAction<SiteSettingsType[]>) => {
      state.site_settings = action.payload
    },
  },
})

export const {
  logoutAuthProfile,
  setAuthProfile,
  updateAuthUserSelectedTenant,
  getUserInfo,
  toggleClientEnabled,
  setAgentSubscribeTime,
  getVersionInfo,
  setVersionDetails,
  setSiteSettings,
} = authSlice.actions
export default authSlice.reducer
